//Components
import { Modal } from "@material-ui/core";

//styling
import { useStyles } from "../Styles/styles";

const SearchModal = ({
  showModal = false,
  setShowModal = () => {},
  keepMounted = true,
  ...props
}) => {
  const classes = useStyles();

  return (
    <Modal
      // disableEnforceFocus
      keepMounted={keepMounted}
      open={showModal}
      onClose={() => setShowModal(false)}
      className={classes.modal}
      data-cy="call-location-modal"
      onKeyDown={e => e.key === "Escape" && setShowModal(false)}
      disablePortal={true}
    >
      {props.children}
    </Modal>
  );
};

export default SearchModal;
